import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { KundeServiceModule } from '..';
import { KundeFilterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    KundeServiceModule
  ],
  declarations: [KundeFilterComponent],
  exports: [KundeFilterComponent],

})
export class KundeFilterComponentModule { }
